<template>
  <button class="icon-btn" :class="{ 'button-disabled': disabled }" :disabled="disabled">
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-grow spinner-grow-sm text-white" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <i v-else class="budicon-check-ui"></i>
    <span v-if="!loading">Lagre</span>
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
button:focus {
  outline: 0;
}
.icon-btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  border-radius: 4px;
  background: $primary;
  border: 1px solid $gray-200;
  box-shadow: $box-shadow-2;
  transition: $transition-base;
  cursor: pointer;

  i {
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
    margin-right: 4px;
  }
  span {
    color: white;
  }
  &:not(.button-disabled):hover {
    background-color: white;
    i,
    span {
      color: $primary;
    }
  }
}

.button-disabled {
  background: rgba($primary, 0.5);
  cursor: not-allowed;
}
</style>
